import React from 'react'
import { Form, Field } from 'redux-form'
import { Link } from 'react-router'

import { Input } from 'components/Input/Input'
import Button from 'components/Button'
import { vRequired, vEmail, vPassword } from 'components/Input/Input.validations'

import cn from 'classnames'
import s from './LoginForm.scss'
import sLay from 'styles/modules/layout.scss'

export default props => {
  const { login, handleSubmit, submitting, afterSubmit, prev } = props

  const onSubmit = formData => login(formData).then(afterSubmit)

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Field
        name="email"
        type="email"
        component={Input}
        label="Your Email"
        validate={[vRequired, vEmail]}
      />
      <Field
        name="password"
        type="password"
        component={Input}
        label="Password"
        validate={[vRequired, vPassword]}
      />
      <div className={cn(sLay['layout-row'], sLay['layout-align-end'])}>
        <Link className={s.forgotLink} to="/password-reset">
          Forgot password?
        </Link>
      </div>
      <div className={cn(sLay['layout-row'], sLay['layout-align-center'])}>
        <div
          className={cn(
            sLay['layout-column'],
            sLay['layout-align-center-center'],
            s.buttonsContainer
          )}
        >
          <Button type="submit" color="tertiary" loading={submitting} disabled={submitting}>
            Next
          </Button>
        </div>
      </div>
      <div
        className={cn(sLay['layout-row'], sLay['layout-align-center'])}
        style={{ margin: '30px 0' }}
      >
        <Button onClick={prev} prev>
          Back
        </Button>
      </div>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/LoginForm/LoginForm.jsx